module.exports = __webpack_public_path__ + "static/img/yk9100.2af4a7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hardware/yk9100.png
// module id = Nf4o
// module chunks = 1